/**
 * @file The enumerator TimelineItemType
 * @author Willem Jan Weitering
 */
/** The enumerator timelineItemType is used to identify the type of timeline-item. */
export var TimelineItemType;
(function (TimelineItemType) {
    TimelineItemType[TimelineItemType["project"] = 0] = "project";
    TimelineItemType[TimelineItemType["profile"] = 1] = "profile";
    TimelineItemType[TimelineItemType["appointment"] = 2] = "appointment";
    TimelineItemType[TimelineItemType["task"] = 3] = "task";
    TimelineItemType[TimelineItemType["notification"] = 4] = "notification";
    TimelineItemType[TimelineItemType["planning"] = 5] = "planning";
    TimelineItemType[TimelineItemType["mind"] = 6] = "mind";
    TimelineItemType[TimelineItemType["realisation"] = 7] = "realisation";
    TimelineItemType[TimelineItemType["holidays"] = 8] = "holidays";
})(TimelineItemType || (TimelineItemType = {}));
